import {
  REQUEST_STOREWASTESTATISTICS,
  REQUEST_STOREWASTESTATISTICS_DONE,
  StoreWasteStatisticsActions
} from "./types";
import { StoreWasteStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchStoreWasteStatistics(): StoreWasteStatisticsActions {
  return {
    type: REQUEST_STOREWASTESTATISTICS,
    payload: []
  };
}

function fetchStoreWasteStatisticsDone(
  storeWasteStatistics: ReadonlyArray<StoreWasteStatistics>
): StoreWasteStatisticsActions {
  return {
    type: REQUEST_STOREWASTESTATISTICS_DONE,
    payload: storeWasteStatistics
  };
}

/* Thunks goes here */
export const thunkFetchStoreWasteStatistics = (
  periodFrom: Date,
  periodTo: Date
) => async (dispatch: any) => {
  try {
    dispatch(fetchStoreWasteStatistics());
    const result = await StatisticsApi.getWasteStatistics(periodFrom, periodTo);

    if (isOk(result)) {
      dispatch(fetchStoreWasteStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchStoreWasteStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
